import { z } from 'zod'

export const TagSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  slug: z.string(),
  count: z.number().int().nonnegative(),
  /**
   * Chip background as `#rrggbb` (Carbon Fields `crb_tag_color`).
   * Empty string = no custom colour, theme default styling.
   */
  color: z.string(),
  /**
   * Manual sort key on the term — same `wp_terms.term_order` channel as
   * the other taxonomies. Read defensively for forward-compat; the tag
   * list UI doesn't drive a drag-to-reorder yet.
   */
  termOrder: z.number().int().nonnegative(),
})

export type Tag = z.infer<typeof TagSchema>
